<div class="duplicate-interactive">
    <div class="exit">
        <button type="button" routerLink="../..">
            <span class="icon-anchor-top"></span>
            <span>Exit</span>
        </button>
    </div>

    <h3 class="title">Duplicate Interactive</h3>

    @if (interactive(); as interactive) {
        <!-- prettier-ignore -->
        <p class="duplicate-caption caption-3">
            Copied from <span class="caption-2">{{ interactive.name }}</span>.
            Changes apply to this new interactive only.
        </p>
        <app-interactive-form
            [initialValue]="formValue()"
            [isSubmitting]="submitting()"
            (formSubmit)="onSubmit($event)"
        ></app-interactive-form>
    } @else {
        <div class="loading"></div>
    }
</div>
